import {
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';

import { DropDownListComponent, MultiSelectComponent, VirtualScroll, DropDownTreeComponent } from '@syncfusion/ej2-angular-dropdowns';
import { Subject, takeUntil } from 'rxjs';
import { ThemeSettingsService } from '@services/theme-settings.service';
import { filter } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { CurrentTheme } from '@models/uiapp-config';

MultiSelectComponent.Inject(VirtualScroll);
DropDownListComponent.Inject(VirtualScroll);
DropDownTreeComponent.Inject(VirtualScroll);

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnDestroy, OnInit {

  private _destroy$ = new Subject<boolean>();
  // WalkMe and Matomo are no longer started from here: the server writes their script tags into the
  // page from deployment configuration (SpaShellRenderer), so no configured URL passes through this
  // code on its way to a script element.

  ngOnDestroy(): void {
    this._destroy$.next(true);
    this._destroy$.complete();
  }

  ngOnInit(): void {
    // Remove the logo container after a short delay to ensure the fade-out is complete
    setTimeout(() => {
      const logoContainer = document.querySelector('.load_center');
      if (logoContainer) {
        logoContainer.remove();
      }
    }, 3000); // 500ms should be enough time for the fade-out to complete
  }

}
